export default __webpack_public_path__ + "static/media/spring.cf41265f.png";